import React from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { connect } from 'react-redux';
import { withTranslation } from '../../lib/translate';
import { deepIsDefined, isDefined} from '../../lib/utils';
import { Spacer, Subtitle, Title } from '../../components/common';
import Incrementer from '../../components/incrementer';
import Basket from '../../lib/basket';
import { getConfig } from '../../appConfig';
import BigNumber from '../../lib/bignumber';
import './index.css';
import { setCommonProp } from '../../store/actions';
import { chevronForward } from 'ionicons/icons';

class ApplyPointsRaw extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      points: this.getRedeemPointsMin(),
    };
  }

  getRedeemPointsMin = () => getConfig().general.redeemPointsMin || 50;

  componentDidMount() {
    const points = Basket.getAppliedPoints();
    if (points > 0) {
      this.setState({ points });
    }
  }

  onIncrementerUpdate = (points) => {
    // from min to 0
    if (points < this.state.points && points < this.getRedeemPointsMin()) {
      points = 0;
    }
    // from 0 to min
    if (points > this.state.points && points < this.getRedeemPointsMin()) {
      points = this.getRedeemPointsMin();
    }
    this.setState({ points });
  };

  applyPoints = () => {
    Basket.applyPoints(this.state.points, this.props.availableBalance, () => {
      this.props.dispatch(setCommonProp('pointsModalOpen', false))
    });
  };

  render() {
    const { __ } = this.props;
    let availableBalance = this.props.availableBalance;
    const { points } = this.state;
    // const formatedAmount = Basket._calculatePointsAppliedPrice(points, false, true)
    const step = getConfig().general.redeemPointsStep || 50;
    const basketTotalInCents =
      new BigNumber(Basket.getTotal()).times(100).toNumber() + Basket.getAppliedPoints();
    let limit = 0;
    if (!isDefined(availableBalance) && availableBalance === null) {
      availableBalance = 0;
    } else {
      limit = parseInt(availableBalance / step) * step;
    }
    // basket total: 5.2$ => 520 => 520/step(e.g. step=100)=5.2 => int(5.2) = 5 => 5 * step(e.g. step=100)
    // limit                    - represents available balance limit
    // pointsLimitBasedOnBasket - represents limit based on basket value
    // we will use lower value
    let pointsLimitBasedOnBasket = basketTotalInCents;
    if (pointsLimitBasedOnBasket > 0) {
      if (basketTotalInCents <= availableBalance) {
        // if user have enough points to cover entire basket total then we should let him to go over step
        limit = basketTotalInCents;
      } else {
        limit = availableBalance;
      }
    }

    return (
      <div className="grid-wrapper grid-justify-center grid-align-start large-padding text-centered">
        <Title className="bold">{__('Redeem points')}</Title>
        <Spacer size={2} />
          <Subtitle className="text-color block">
            {__('Select the number of points you would like to redeem')}
          </Subtitle>
          <Spacer size={0} />
          <Subtitle className='text-color block' ><span className='primary-color'>{availableBalance}</span> {__('points available')}</Subtitle>
          <Spacer size={4} />

          <Incrementer
            maxLimit={limit < pointsLimitBasedOnBasket ? limit : pointsLimitBasedOnBasket}
            onUpdate={this.onIncrementerUpdate}
            quantity={points}
            step={step}
            allowNegative={false}
            large={true}
          />
          <Spacer size={0} />
          <Subtitle className={'primary-color'}>{`${__('value to apply:')} ${Basket.formatPrice(
            Basket.calculatePointsAppliedPrice(points))}`}</Subtitle>
          <Spacer size={2} />
          {availableBalance < this.getRedeemPointsMin() && (
            <Subtitle className="centered block danger-color">
              {__('You require')} {this.getRedeemPointsMin()} {__('points for redemption')}
            </Subtitle>
          )}
          <Spacer size={4} />

          <div className="flex-min">
            <IonButton
              className='large-button'
              expand="block"
              color="primary"
              disabled={
                points === 0
                  ? false
                  : availableBalance < this.getRedeemPointsMin() ||
                    parseInt(Basket.getSubTotal() * 100) < this.getRedeemPointsMin()
                    ? true
                    : false
              }
              onClick={() => this.applyPoints()}
            >
              {__('Apply')}
              <IonIcon slot='end' icon={chevronForward} />

            </IonButton>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    availableBalance: deepIsDefined(store, 'profile.profile.available_balance')
      ? store.profile.profile.available_balance
      : 0,
    basketUpadated: store.orders.basketUpdated,
  };
};

export const ApplyPoints = connect(mapStateToProps)(withTranslation(ApplyPointsRaw));

const ApplyPointsWrapped = (props) => (
  <ApplyPoints {...props} />
);

export default withTranslation(ApplyPointsWrapped);
